import { ROLE_PERMISSIONS, BRAND_TIER_RULESET } from '@shared/constants';

const isAuthorized = () => {
  const role = localStorage.getItem('role');
  const rolePermissions = ROLE_PERMISSIONS[role];
  return requiredPermission => {
    if (process.env?.NODE_ENV === 'test') {
      const rolePermissions =
        ROLE_PERMISSIONS[localStorage.getItem('role') || 'Admin'];
      return rolePermissions.indexOf(requiredPermission) !== -1;
    }

    if (!rolePermissions || rolePermissions.length === 0) {
      return false;
    }

    return rolePermissions.indexOf(requiredPermission) !== -1;
  };
};

export const hasFeatureAccess = (accountData, feature) => {
  if (!(accountData.brand && accountData.edition)) {
    return false;
  }

  let brandName = Object.keys(BRAND_TIER_RULESET).find(
    element => accountData.brand.toLowerCase() === element.toLowerCase()
  );

  const brand = BRAND_TIER_RULESET[brandName];
  if (brand) {
    let edition = null;
    Object.keys(brand).forEach(brandEdition => {
      if (
        accountData.edition
          .toLowerCase()
          .indexOf(brandEdition.toLowerCase()) !== -1
      ) {
        edition = brandEdition;
      }
    });

    return brand[edition] ? brand[edition][feature] : true;
  } else {
    return true;
  }
};

export default isAuthorized();
